import { useFormContext } from 'react-hook-form'
import { classNames } from 'utils/classNames'
import { ErrorMessage } from './ErrorMessage'
import { useState } from 'react'
import { InformationTip } from '../tooltips/InformationTip'
import { FaEye } from 'react-icons/fa'
import { FaEyeSlash } from 'react-icons/fa'

type Props = {
  placeholder?: string
  label?: string
  required?: boolean
  autoComplete?: 'off' | 'on'
  disabled?: boolean
  type?: string
  name: string
  discription?: string
}

export const InputText = (props: Props) => {
  const {
    label,
    placeholder,
    required = false,
    autoComplete = 'off',
    disabled = false,
    name,
    type = 'text',
    discription
  } = props
  const { register } = useFormContext()
  // パスワード表示制御ようのstate
  const [isRevealPassword, setIsRevealPassword] = useState(true)

  const togglePassword = () => {
    setIsRevealPassword((prevState) => !prevState)
  }
  const baseStyle =
    'w-full rounded border border-[#ddd] px-3 py-2 text-sm outline-none'
  const disabledStyle = 'bg-gray-50 text-gray-500'
  return (
    <div className="relative flex flex-col">
      {label && (
        <div className={'flex items-center justify-between'}>
          <label className={'mb-1.5 block text-sm font-medium text-[#555]'}>
            {label}
            {required && <span className={'text-red-500'}>{' *'}</span>}
          </label>
          {discription && (
            <InformationTip dataId={name} discription={discription} />
          )}
        </div>
      )}
      <div className="relative block">
        <input
          {...register(name)}
          className={classNames([
            baseStyle,
            disabled ? disabledStyle : '',
            'focus:border-b-teal-400'
          ])}
          type={
            type === 'password'
              ? isRevealPassword
                ? 'password'
                : 'text'
              : type
          }
          autoComplete={autoComplete}
          placeholder={placeholder}
          disabled={disabled}
        />
        {type === 'password' && (
          <span
            onClick={togglePassword}
            role="presentation"
            className={'absolute left-auto right-2 top-2'}
          >
            {isRevealPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        )}
      </div>
      <ErrorMessage name={name} />
    </div>
  )
}
